/**
 * UI adapter: bridges tick frame to TriggerScriptedEvent use case (UC-24)
 */
import { architectureFeatures } from '../../../infrastructure/config/features';
import {
  triggerScriptedEventUseCase,
} from '../../../infrastructure/di/container';
import { TriggerScriptedEventUseCase } from '../../../application/use-cases/TriggerScriptedEventUseCase';
import type {
  TriggerScriptedEventInput,
  TriggerScriptedEventOutput,
} from '../../../application/use-cases/TriggerScriptedEventUseCase';

export type { TriggerScriptedEventInput, TriggerScriptedEventOutput };

export function executeTriggerScriptedEvent(
  input: TriggerScriptedEventInput,
): TriggerScriptedEventOutput {
  if (!architectureFeatures.useScriptedEventUseCase) {
    throw new Error('useScriptedEventUseCase feature flag is disabled');
  }
  return triggerScriptedEventUseCase.execute(input);
}

export function executeLegacyTriggerScriptedEvent(
  input: TriggerScriptedEventInput,
): TriggerScriptedEventOutput {
  return new TriggerScriptedEventUseCase().execute(input);
}

export function resolveTriggerScriptedEvent(
  input: TriggerScriptedEventInput,
): TriggerScriptedEventOutput {
  if (architectureFeatures.useScriptedEventUseCase) {
    return executeTriggerScriptedEvent(input);
  }
  return executeLegacyTriggerScriptedEvent(input);
}